import types from './constants';

export const changeLocale = languageLocale => ({
  type: types.CHANGE_LOCALE,
  locale: languageLocale
});
